import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import { StringValue } from "./StringValue";
import CardContent from "@material-ui/core/CardContent";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Upgrading Hero">
      <CardContent>
        <AccountDetailsSection task={task} />
        <StringValue
          label={"Selected Hero"}
          value={task.taskstatusdetail.selectedhero.heroname}
        />
        <StringValue
          label={"Unlock Gem slots"}
          value={task.taskstatusdetail.unlockAllgemSlotsOnGear}
        />
        <StringValue
          label={"Upgrade Gears using Valtos"}
          value={task.taskstatusdetail.upgradeAllGearToMaxUsingValtoRunes}
        />
        <StringValue
          label={"Upgrade All Skills on hero"}
          value={task.taskstatusdetail.upgradeAllSkillsOnHero}
        />
        <StringValue
          label={"Enhance all gear on hero using Titaniums"}
          value={task.taskstatusdetail.enahnceAllGearOnHeroUsingTitaniums}
        />
        <StringValue
          label={"Upgrade Assigned Mount To Max"}
          value={task.taskstatusdetail.upgradeAssignedMountToMax}
        />
        <StringValue
          label={"Gem Config:"}
          value={task.taskstatusdetail.gemconfig}
          valueParser={(v) => {
            if (v === "equipHeroWithBalancedDefence") {
              return "None";
            } else if (v === "equipHeroWithBalancedDefence") {
              return "Pure Def";
            } else if (v === "equipHeroWithBalancedAtk") {
              return "Pure Atk";
            }
            return null;
          }}
        />
        <StatusSection task={task} />
        <StringValue
          label={"Currently running:"}
          value={task.taskstatusdetail.currentlyrunning}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
